import { z } from "zod";

// 比赛 schema 定义
export const CompetitionSchema = z.object({
  id: z.string(),
  name: z.string(),
  date: z.string(),
  location: z.string(),
  teams: z.array(
    z.object({
      name: z.string(),
      score: z.number(),
      logo: z.string().optional(),
    })
  ),
  highlights: z.array(z.string()).optional(),
  theme: z
    .object({
      primaryColor: z.string(),
      secondaryColor: z.string(),
      backgroundColor: z.string(),
    })
    .optional(),
});

export type Competition = z.infer<typeof CompetitionSchema>;

// 视频 Props schema
export const VideoPropsSchema = z.object({
  competition: CompetitionSchema,
});

export type VideoProps = z.infer<typeof VideoPropsSchema>;
